var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-cc dir-col flex-auto"},[_c('SMS',_vm._b({},'SMS',{restOfCount: _vm.restOfCount, resendOtp: _vm.resendOtp, loading: _vm.loading, handleVerify: _vm.handleVerify},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }